import React, {Component} from 'react';
import PropTypes from 'prop-types';
import BackEnd from "../../../../backend/BackEnd";
import ActionLink from "../../../../controls/ActionLink";
import FileIcon from "../../../../utils/components/FileIcon";
import PdfViewerModal from "../../../../modals/PdfViewerModal";
import ImageViewerModal from "../../../../modals/ImageViewerModal";

const $ = window.jQuery;

class Documents extends Component {
    static propTypes = {
        entityId: PropTypes.number.isRequired,
        entityName: PropTypes.string.isRequired,
        propertyName: PropTypes.string.isRequired
    };
    static defaultProps = {};
    state = {
        showPdfViewerModal: false,
        showImageViewerModal: false,
        currentDocumentId: null,
        documents: []
    };

    async componentDidMount() {
        const {entityId, entityName, propertyName} = this.props;

        let getOrderDocuments = new BackEnd.Documents.GetOrderDocuments();
        let documents = await getOrderDocuments.call({
            entityId,
            entityName,
            propertyName
        });

        this.setState({documents});
    }

    render() {
        const props = this.props;

        if (this.state.documents.length === 0) {
            return (
                <div>Прикреплённые документы отсутствуют</div>
            );
        }
        else {
            return (
                <div>
                    {/*<div className="row clearfix">*/}
                    {/*<div className="col-md-12">*/}
                    {/*<button type="button" className="btn btn-xs btn-outline pull-right">*/}
                    {/*Прикрепить*/}
                    {/*</button>*/}
                    {/*</div>*/}
                    {/*</div>*/}
                    <div className="row">
                        <div className="col-md-12">
                            {this.state.documents.map(document =>
                                <ActionLink key={document.id} className="label m-r-1"
                                            onClick={() => this.downloadOrOpenDocument(document)}>
                                    <FileIcon extension={document.extension}/> {document.name}
                                </ActionLink>
                            )}
                            <div className="pull-right">
                                <button type="button" className="btn btn-outline btn-xs"
                                        onClick={() => this.downloadAll()}>
                                    <i className="fa fa-cloud-download"/> Скачать все
                                </button>
                            </div>
                        </div>
                    </div>
                    <PdfViewerModal documentId={this.state.currentDocumentId}
                                    show={this.state.showPdfViewerModal}
                                    onHide={() => this.setState({showPdfViewerModal: false})}/>
                    <ImageViewerModal documentId={this.state.currentDocumentId}
                                      show={this.state.showImageViewerModal}
                                      onHide={() => this.setState({showImageViewerModal: false})}/>
                </div>
            );
        }
    }

    async downloadOrOpenDocument(document) {
        if (document.extension === ".pdf") {
            this.setState({
                showPdfViewerModal: true,
                currentDocumentId: document.id
            });
        }
        else if (document.extension === ".jpg" || document.extension === ".jpeg") {
            this.setState({
                showImageViewerModal: true,
                currentDocumentId: document.id
            });
        }
        else {
            let getFileToken = new BackEnd.Tokens.GetFileToken();
            let token = await getFileToken.call();

            let downloadFile = new BackEnd.Documents.Download();
            let href = downloadFile.createUrl({documentId: document.id, token});

            $('<a />').attr({href, download: 'download'}).get(0).click();
        }
    }

    async downloadAll() {
        const {entityId, entityName, propertyName} = this.props;

        let getFileToken = new BackEnd.Tokens.GetFileToken();
        let token = await getFileToken.call();

        let downloadFilesPackage = new BackEnd.Documents.DownloadFilesPackage();
        let href = downloadFilesPackage.createUrl({
            entityId,
            entityName,
            propertyName,
            token
        });

        $('<a />').attr({href, download: 'download'}).get(0).click();
    }
}

export default Documents;


// WEBPACK FOOTER //
// ./src/pages/TenderBlock/TenderRequests/components/Documents.js